/* Humans Against — homepage interactions & measurement
   - Plays UGC videos only while in view (perf + battery)
   - Respects prefers-reduced-motion
   - Per-video sound toggle
   - Pushes GA4 / dataLayer events for CTAs, video plays, scroll depth
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, params) {
    params = params || {};
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
  }

  /* ---- CTA / link click tracking ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ha-event]');
    if (!el) return;
    track(el.getAttribute('data-ha-event'), {
      label: el.getAttribute('data-ha-label') || el.textContent.trim().slice(0, 60),
      location: el.getAttribute('data-ha-location') || ''
    });
  });

  /* ---- UGC videos: play in view, sound toggle ---- */
  function initVideos() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.ha-video, .ha-how__video'));
    if (!cards.length) return;

    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      cards.forEach(function (c) { if (c.querySelector('video')) io.observe(c); });
    }

    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      var btn = card.querySelector('.ha-video__sound');
      var played = false;
      v.addEventListener('playing', function () {
        if (!played) { played = true; track('ugc_video_play', { handle: card.getAttribute('data-handle') || '' }); }
      });
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // mute every other video first
          cards.forEach(function (c) {
            var ov = c.querySelector('video');
            if (ov && ov !== v) { ov.muted = true; var ob = c.querySelector('.ha-video__sound'); if (ob) ob.setAttribute('aria-pressed', 'false'); }
          });
          v.muted = !v.muted;
          btn.setAttribute('aria-pressed', String(!v.muted));
          if (!v.paused) { /* keep playing */ } else { v.play().catch(function () {}); }
        });
      }
    });
  }

  /* ---- Scroll depth ---- */
  function initScrollDepth() {
    var marks = [25, 50, 75, 100], fired = {};
    function onScroll() {
      var doc = document.documentElement;
      var scrolled = (window.scrollY + window.innerHeight) / doc.scrollHeight * 100;
      marks.forEach(function (m) {
        if (!fired[m] && scrolled >= m) { fired[m] = true; track('scroll_depth', { percent: m }); }
      });
      if (fired[100]) window.removeEventListener('scroll', onScroll);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() { initVideos(); initScrollDepth(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
